import { useTranslation } from "react-i18next";

const HeaderSideToggler = () => {
	const { t } = useTranslation();
	return (
		<button
			className="btn btn-link btn-sm text-decoration-none border-0 p-2 p-sm-3"
			type="button"
			data-bs-toggle="offcanvas"
			data-bs-target="#root-dashboard-navigation-offcanvas"
			aria-controls="root-dashboard-navigation-offcanvas"
			aria-label={t("actions.open_navigation_menu")}>
			<svg
				xmlns="http://www.w3.org/2000/svg"
				width="1.722222rem"
				height="1.111111rem"
				viewBox="0 0 31.368 20"
				aria-hidden="true">
				<g transform="translate(-328.513 -30.089)">
					<line
						x1="31.368"
						transform="translate(328.513 31.089)"
						fill="none"
						stroke="currentColor"
						strokeWidth="2"></line>
					<line
						x1="31.368"
						transform="translate(328.513 40.089)"
						fill="none"
						stroke="currentColor"
						strokeWidth="2"></line>
					<line
						x1="31.368"
						transform="translate(328.513 49.089)"
						fill="none"
						stroke="currentColor"
						strokeWidth="2"></line>
				</g>
			</svg>
		</button>
	);
};

export default HeaderSideToggler;
